/**
 * Converts an UPPER_SNAKE_CASE tag key to a metadata key for Algolia.
 * e.g. "NEW_LOW_PRICE" -> "metadata.newLowPrice"
 *      "NEW" -> "metadata.new"
 *      "SUSTAINABLE" -> "metadata.sustainable"
 */
export const toMetadataKey = (tagKey: string): string => {
  const camelCase = tagKey
    .toLowerCase()
    .split('_')
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');

  return `metadata.${camelCase}`;
};

/**
 * Converts a metadata key back to an UPPER_SNAKE_CASE tag key.
 * e.g. "metadata.newLowPrice" -> "NEW_LOW_PRICE"
 *      "metadata.new" -> "NEW"
 *      "metadata.sustainable" -> "SUSTAINABLE"
 */
export const fromMetadataKey = (metadataKey: string): string => {
  const withoutPrefix = metadataKey.replace(/^metadata\./, '');

  const snakeCase = withoutPrefix.replace(/[A-Z]/g, (match) => `_${match}`).toUpperCase();

  return snakeCase;
};
